// TODO use/update models
import { CrudState } from "@/store/modules/crud/State";
import ICountry from "@/models/ICountry";

export class State extends CrudState {
  dataList: Array<ICountry> = [];
  dataItem: ICountry | null = null;
}
